import React from 'react';

import { safeMap } from '@src/utils/mapper';
import { getPostDate, getReadingTime } from '@src/utils/calculations';

import { StandardSection } from '@commons/standard-section/StandardSection';

import * as styles from './header.module.scss';

export default function Header({ categories, thumbnail, date, title, words }) {
  const postDate = getPostDate(date);
  const readingTime = getReadingTime(words);

  return (
    <StandardSection className={styles.singleBlogPostHeader}>
      <div className={styles.meta}>
        <p className={styles.data}>{postDate}</p>
        <div className={styles.categoriesContainer}>
          {safeMap(categories, (el, index) => {
            if (!el || !el.frontmatter) return null;
            return (
              <div key={index} className={styles.category}>
                {el.frontmatter.postCategoryName}
              </div>
            );
          })}
        </div>
      </div>
      <h1 className={styles.mainTitle}>{title}</h1>
      <div className={styles.readingTime}>
        <p>{readingTime} reading</p>
      </div>
      <img loading="lazy" src={thumbnail.publicURL} className={styles.backgroundImage} alt={title} />
    </StandardSection>
  );
}
